<template>
  <el-dialog
    class="customDialogForm"
    width="600px"
    :title="'服务续费'"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <el-alert style="margin-bottom: 16px" title="请注意，商店续费无需进行支付" type="warning"/>
    <el-form
      autocomplete="on"
      style="padding: 0 90px;"
      ref="Forms"
      label-position="left"
      :model="captchaForm"
      @submit.native.prevent
    >
      <el-form-item
        prop="appname"
        label="应用名称"
        :label-width="formLabelWidth"
      >
        <el-input
          :disabled="true"
          style="width: 100%;line-height: 37px;"
          v-model="captchaForm.name"
        />
      </el-form-item>
        <el-form-item
          prop="billCycle"
          label="周期"
          :label-width="formLabelWidth"
        >
          <el-input :disabled="true" v-model="captchaForm.billCycleZh" :min="1" />
        </el-form-item>
        <el-form-item
          prop="num"
          label="续费数量:"
          :label-width="formLabelWidth"
        >
          <el-input-number
            style="width: 100%;line-height: 37px;"
            v-model="captchaForm.num"
            @change="handleChange"
            :min="1"
          />
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getAppDetailApi, getAppUpVersion } from '@/api/appStore';
export default {
  name: 'ServiceRenew',
  props: {
    dialogVisible: {
      type: Boolean,
      default: true
    },
    appDetail: {
      type: Object,
      default: () => null
    },
    identity: {
      type: String,
      default: 'buyers'
    },
    orderType: {
      type: String,
      default: 'renew'
    }
  },
  data() {
    return {
      Loading: false,
      formLabelWidth: '100px',
      captchaForm: {
        num: 1,
        captcha_id: '',
        captcha_answer: '',
        price: 0,
        billCycle: '',
        name: ''
      },
      totalPrice: 0,
      billCycles: [
        {
          label: '周',
          value: 'week'
        },
        {
          label: '月度',
          value: 'month'
        },
        {
          label: '季度',
          value: 'quarter'
        },
        {
          label: '年度',
          value: 'year'
        }
      ],
      value: '',
      loading: false,
      versionList: [],
      curVersion: '',
      curVersionPackageList: [],
      allPackageInfo: {},
      curPackageInfo: {},
      showDateZh: { month: '月', year: '年', quarter: '季度', week: '周' }
    };
  },
  created() {
    if (this.appDetail) {
      const { combo, appName } = this.appDetail;
      if (combo) {
        this.captchaForm.billCycle = combo.billCycle;
        this.captchaForm.billCycleZh = this.showDateZh[combo.billCycle];
        this.captchaForm.price = combo.price;
        this.totalPrice = combo.price;
      }
      this.captchaForm.name = appName;
    }
  },
  methods: {
    submit() {
      this.$refs.Forms.validate(valid => {
        if (valid) {
          this.Loading = true;
          const {
            appID,
            marketID
          } = this.appDetail;
          const obj = {
            marketID,
            appID: appID,
            comboQuantity: this.captchaForm.num
          };
          this.$store
            .dispatch('MerchantsAppRenewal', obj)
            .then(res => {
              this.Loading = false;
              this.handleClose(true, true);
              this.$message.success('续费成功');
            })
            .catch(() => {
              this.Loading = false;
            });
        }
      });
    },
    handleChange() {
      const { price, num } = this.captchaForm;
      this.totalPrice = price * num;
    },
    handleClose(_, updata = false) {
      this.$emit('handleClose', updata);
      this.$refs.Forms.resetFields();
    },
    // 应用详情
    getAppDetail() {
      const { appKeyID, marketID } = this.appDetail;
      getAppDetailApi({
        marketId: marketID,
        appId:
          this.identity === 'buyers' ? appKeyID : this.appDetail.combo.appKeyID
      })
        .then(res => {
          if (res) {
            this.allPackageInfo = {};
            this.curVersionPackageList = [];
            this.curPackageInfo = {};
            // this.appDetailInfo = res;
            if (res.versions && res.versions.length) {
              this.versionList = res.versions;
              this.curVersion = res.versions[0].appVersion;
            }
            if (res.packages && res.packages.length) {
              const data = {};
              res.packages.forEach(item => {
                if (!data[item.version]) data[item.version] = [];
                data[item.version].push(item);
              });
              this.allPackageInfo = data;
              this.curVersionPackageList = data[this.curVersion] || [];
              if (this.curVersionPackageList.length) {
                this.curPackageInfo = this.curVersionPackageList[0];
              }
            }
          }
        })
        .catch(() => {
          this.detailLoading = false;
        });
    },
    // 升级版本
    UpVersion() {
      const { marketID } = this.appDetail;
      getAppUpVersion({
        marketID,
        appID: this.appDetail.appID
      })
        .then(res => {
          const arr = [];
          if (res && res.length > 0) {
            this.versionList.map(item => {
              res.map(items => {
                if (item.appVersion == items) {
                  arr.push(item);
                }
              });
            });
            this.versionList = arr;
            this.curVersion = res[0];
          } else {
            // this.versionList = [];
            // this.curVersion = '';
          }
        })
        .catch(() => {
          this.detailLoading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.input-with-select .el-input-group__prepend {
  background: #f9f9f9;
}
.verification-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/deliverManage/apps/components/renew.vue